import { Bell, CheckCheck, TriangleAlert } from "lucide-react";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useOrganizationContextNotifications } from "@/hooks/use-organization-context-notifications";

export function OrganizationContextNotificationBell() {
  const { notifications, markRead, markAllRead } = useOrganizationContextNotifications();
  const items = notifications.data ?? [];
  const unread = items.filter((item) => item.readAt === null);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" size="icon" aria-label={`Quarantine notifications${unread.length ? ` (${unread.length} unread)` : ""}`} className="relative bg-white">
          <Bell className="h-4 w-4" aria-hidden />
          {unread.length > 0 && <span className="absolute -right-1 -top-1 min-w-4 rounded-full bg-amber-600 px-1 text-[10px] leading-4 text-white">{unread.length}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between border-b border-stone-200 px-3 py-2">
          <p className="font-inter text-sm font-semibold text-stone-900">Quarantine alerts</p>
          <Button type="button" variant="ghost" size="sm" disabled={!unread.length || markAllRead.isPending} onClick={() => markAllRead.mutate()}><CheckCheck className="h-4 w-4" aria-hidden /> Mark all read</Button>
        </div>
        <ul className="max-h-80 overflow-auto">
          {items.map((item) => <li key={item.deliveryId} className={item.readAt ? "border-b border-stone-100 p-3" : "border-b border-amber-100 bg-amber-50 p-3"}>
            <div className="flex gap-2"><TriangleAlert className="mt-0.5 h-4 w-4 shrink-0 text-amber-700" aria-hidden /><div className="min-w-0"><p className="font-inter text-sm font-medium text-stone-900">{item.title} needs review</p><p className="mt-1 font-inter text-xs text-stone-600">{item.organization} · {item.reasonCategory} · {format(new Date(item.uploadTime), "MMM d, yyyy")}</p><p className="mt-1 font-inter text-xs text-stone-600">Resolution: Review the document status and upload a privacy-safe revision if needed.</p><Link className="mt-2 inline-block font-inter text-xs font-medium text-bodhi-teal underline" to={item.actionPath} onClick={() => { if (!item.readAt) markRead.mutate(item.deliveryId); }}>Review document</Link></div></div>
          </li>)}
          {!items.length && <li className="p-4 text-center font-inter text-sm text-stone-500">No quarantine alerts.</li>}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
